import React from 'react';
import { z } from 'zod';
import { Input } from '@/components/ui/input';
import { useFormContext } from 'react-hook-form';
import { QuestionData } from '../types';

interface NumberFieldProps {
  question: QuestionData;
  placeholder?: string;
  disabled?: boolean;
}

const NumberFieldComponent: React.FC<NumberFieldProps> = ({
  question,
  placeholder,
  disabled,
}) => {
  const { register } = useFormContext();
  return (
    <Input
      {...register(question.slug, {
        valueAsNumber: true,
      })}
      type="number"
      placeholder={placeholder}
      className="w-full"
      disabled={disabled}
    />
  );
};

const createNumberSchema = (question: QuestionData): z.ZodTypeAny => {
  let schema = z.number({ invalid_type_error: 'Must be a number' });
  const v = question.validations || {};

  if (v.min !== undefined) {
    schema = schema.min(v.min, `Minimum value is ${v.min}`);
  }
  if (v.max !== undefined) {
    schema = schema.max(v.max, `Maximum value is ${v.max}`);
  }

  return question.required ? schema : schema.optional();
};

const getDefaultValue = (question: QuestionData): number => {
  // Special case for number fields with min validation
  if (question.validations?.min !== undefined) {
    return question.validations.min;
  }
  return 0;
};

export const NumberField = {
  component: NumberFieldComponent,
  createSchema: createNumberSchema,
  getDefaultValue: getDefaultValue,
};
